import styled from 'styled-components';

const EmbeddedIFrame = styled.iframe`
    border-width: 0px;
    height: 100vh;
`;

export default EmbeddedIFrame;



// WEBPACK FOOTER //
// ./src/components/atoms/EmbeddedIFrame.js